export const PLATFORM_ADMIN_ROLE = 'platform_admin'
/** @deprecated Legacy JWT role — treated as platform_admin with ALL scope */
export const SUPER_ADMIN_ROLE = 'super_admin'

export const ADMIN_SCOPES = ['FREE', 'PAID', 'ALL'] as const
export type AdminScope = (typeof ADMIN_SCOPES)[number]

export class ForbiddenRoleError extends Error {
  code: string

  constructor(message = 'This panel is for platform operators only.') {
    super(message)
    this.name = 'ForbiddenRoleError'
    this.code = 'FORBIDDEN_ROLE'
  }
}

export function normalizeAdminScope(raw: unknown, fallback: AdminScope = 'ALL'): AdminScope {
  const value = String(raw ?? '').trim().toUpperCase()
  if (value === 'FREE' || value === 'PAID' || value === 'ALL') return value
  return fallback
}

/** Returns true when the user may access the platform (business) admin. */
export function isPlatformAdminRole(role: string | null | undefined): boolean {
  return role === PLATFORM_ADMIN_ROLE || role === SUPER_ADMIN_ROLE
}

/** @deprecated Use {@link isPlatformAdminRole} */
export function isSuperAdminRole(role: string | null | undefined): boolean {
  return isPlatformAdminRole(role)
}

export function isAllScope(adminScope: AdminScope | null | undefined): boolean {
  return normalizeAdminScope(adminScope) === 'ALL'
}

export function platformScopeBadgeLabel(adminScope: AdminScope | null | undefined): string | null {
  const scope = normalizeAdminScope(adminScope)
  if (scope === 'ALL') return 'ALL PLATFORM'
  if (scope === 'FREE') return 'FREE PLATFORM'
  if (scope === 'PAID') return 'PAID PLATFORM'
  return null
}

/** Throws {@link ForbiddenRoleError} when role is not a platform operator. */
export function assertPlatformAdminRole(role: string | null | undefined): void {
  if (!isPlatformAdminRole(role)) {
    throw new ForbiddenRoleError()
  }
}

/** @deprecated Use {@link assertPlatformAdminRole} */
export function assertSuperAdminRole(role: string | null | undefined): void {
  assertPlatformAdminRole(role)
}
